import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'dialog-title',
    template: `
<div class="dialog-title" [style.fontSize]="fontSize" [style.height]="titleHeight" [style.backgroundColor]="backgroundColor">
    <span class="title">
        {{ title }}
    </span>
</div>
`,
    styles: [`
    .dialog-title .title { margin: auto; color: white; font-weight: bold }
    .dialog-title { height: 60px; display: flex; }
`],
    standalone: true,
    imports: [CommonModule]
})

export class DialogTitleComponent {
    @Input() backgroundColor = '#000'
    @Input() title = 'Dialog Title'
    @Input() titleHeight = '60px'
    @Input() fontSize = '16px'
}
